import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { fetchTaxRates } from '@modules-deprecated/app/taxrates/query-api'

import { QueryKeys } from '../../../enums/queryKeys'

interface UseFetchPurchaseTaxRatesOptions {
  selectedTaxRateId?: string
}

// Shares `[QueryKeys.TaxRates, organizationId]` with the other tax-rate queries, so this must
// fetch the same unfiltered payload and narrow it here. A selected inactive rate stays available.
export const useFetchPurchaseTaxRates = (options: UseFetchPurchaseTaxRatesOptions = {}) => {
  const { selectedTaxRateId } = options
  const { organization } = useUserOrganization()
  const organizationId = organization?.id

  const { data: taxRatesData, isLoading } = useQuery(
    [QueryKeys.TaxRates, organizationId],
    () => fetchTaxRates({ organizationId: organizationId as string }),
    { enabled: !!organizationId },
  )

  const purchaseTaxRates = useMemo(
    () =>
      (taxRatesData?.taxRates ?? []).filter(
        (taxRate) => taxRate.appliesToPurchases && (taxRate.isActive || taxRate.id === selectedTaxRateId),
      ),
    [selectedTaxRateId, taxRatesData],
  )

  return { isLoading, purchaseTaxRates }
}
